<template>
  <v-card
      class="py-0 pl-2" outlined
  >
    <div class="d-flex flex-no-wrap justify-space-between align-center">

      <div >
        <v-avatar tile size="45px">
          <v-img :src="getImage"></v-img>
        </v-avatar>
      </div>

      <div class="subtitle-1 font-weight-bold text-left flex-grow-1 pl-3" :style="{color: getFontColor}">
        <template v-if="shortName">
          <span  :class="hasStock ? getFontColor : 'red--text darken--1'" dark>
               {{product.shortName}}
          </span>

        </template>
        <v-clamp v-else autoresize :max-lines="1">
          {{ product.name.charAt(0).toUpperCase() + product.name.toLowerCase().substring(1) }}
        </v-clamp>
      </div>

      <div>
        <v-card-actions class="py-1">
          <!--REMOVE-->
          <v-btn v-if="!shortName && editQuantity && quantity > 0"
                 fab x-small outlined
                 color="red"
                 @click="removeProduct(product, category)"
          >
            <v-icon>{{ quantity === 1 ? 'delete' : 'remove' }}</v-icon>
          </v-btn>

          <v-text-field
              type="number"
              dense
              single-line solo
              hide-details
              class="centered-input text-center mx-1"
              v-model.number="localQuantity"
              :style="{width: '60px'}"
              :append-icon="null"
              min="0"
          ></v-text-field>
          <!--ADD-->
          <v-btn v-if="!shortName && editQuantity"
                 fab x-small
                 :color="hasStock ? getFontColor : 'red darken--1'" dark
                 @click="addProduct(product, category, order)"
          >
            <v-icon>{{hasStock ? 'add' : 'dangerous'}}</v-icon>
          </v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-card>
</template>

<script>
import VClamp from 'vue-clamp'

export default {
  name: "BarProductCard",
  components: {
    VClamp
  },
  props: {
    product: {type:Object},
    category: {type:Object},
    quantity: {type:Number, default: null},
    order: {type: Number, default: 999},
    stockQuantity: {type:Number, default: 1000},
    editQuantity: {type: Boolean, default: false},
    shortName: {type: Boolean, default: false},

  },
  computed: {
    getImage(){
      let imageCategory
      if(this.product.imageCategory){
        imageCategory = this.product.imageCategory.find(i=> i.category === this.category.id)
      }
      return (imageCategory && imageCategory.image) ? imageCategory.image : this.product.image
    },
    localQuantity: {
      get() {
        return this.quantity
      },
      set(val) {
        if(val === '') val = 0
        val = Math.abs(val)
        this.$store.commit('changeItemQuantity', {product: this.product, category: this.category, quantity: val, order: this.order})
      }
    },
    getFontColor() {
      return this.category.fontColor ? this.category.fontColor : null
    },
    hasStock(){
      return (this.quantity < this.stockQuantity)
    }
  },
  data() {
    return {
      elevation: 2
    }
  },
  methods: {
    addProduct(product,category, order) {
      if(this.quantity < this.stockQuantity){
        this.$store.commit('addItem', {product,category, order})
      }
    },
    removeProduct(product,category) {
      this.$store.commit('removeItem', {product,category})
    },
  }
}
</script>

<style scoped>

</style>
